import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InterventionTeamManagerComponent} from './intervention-team-manager.component';
import {ChappsListModule} from "@npm.chapps.com/chapps.common.angular.library";
import {TranslateModule} from "@ngx-translate/core";
import {FormsModule} from "@angular/forms";
import {InterventionTeamEditorModule} from "../intervention-team-editor/intervention-team-editor.module";
import {TeamContactDialogModule} from "../../contacts/new-team-contact-dialog/team-contact-dialog.module";
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {MdProgressSpinnerModule} from 'ng-uikit-pro-standard';
import {InterventionTeamManagerState} from './intervention-team-manager.state';


@NgModule({
  declarations: [
    InterventionTeamManagerComponent,
  ],
  imports: [
    CommonModule,
    ChappsListModule,
    TranslateModule,
    FormsModule,
    InterventionTeamEditorModule,
    TeamContactDialogModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MdProgressSpinnerModule,
  ],
  providers: [
    InterventionTeamManagerState,
  ]
})
export class InterventionTeamManagerModule {
}
